import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DirectivesModule } from '../directives/directives.module';
import { PipesModule } from '../pipes/pipes.module';
import { AccountAccessComponent } from './account-access/account-access.component';
import {
  AccountAccessReasonDialogComponent
} from './account-access/account-access-reason-dialog/account-access-reason-dialog.component';
import { UserRoutingModule } from './user-routing.module';
import { UserDetailsComponent } from './user-details/user-details.component';
import { UserMessagesComponent } from './user-messages/user-messages.component';
import { UserMessagesViewComponent } from './user-messages/user-messages-view/user-messages-view.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ClientSitesComponent } from '../client/client-sites/client-sites.component';
import { UserMessagesFilterComponent } from './user-messages-filter/user-messages-filter.component';
import { UserDynamicFormsComponent } from './user-dynamic-forms/user-dynamic-forms.component';
import { MatComponentsModule } from '../mat-components/mat-components.module';
import { UserDynamicFormsEditComponent } from './user-dynamic-forms-edit/user-dynamic-forms-edit.component';
import { UtilsModule } from '../utils/utils.module';
import { UserDynamicFormsTemplateSelectorComponent } from './user-dynamic-forms-template-selector/user-dynamic-forms-template-selector.component';
import { UserDynamicFormsCreateWizardComponent } from './user-dynamic-forms-create-wizard/user-dynamic-forms-create-wizard.component';
import { ClientSitesSelectorComponent } from '../client/client-sites-selector/client-sites-selector.component';
import { SharedModule } from '../shared/shared.module';
import { UserDynamicFormsFilterComponent } from './user-dynamic-forms-filter/user-dynamic-forms-filter.component';
import {UserTasksComponent} from "./user-tasks/user-tasks.component";
import {UserTasksEditComponent} from "./user-tasks-edit/user-tasks-edit.component";
import {UserTasksFilterComponent} from "./user-tasks-filter/user-tasks-filter.component";
import {FilesModule} from "../files/files.module";
import {MultiAccountDashboardModule} from "./multi-account-dashboard/multi-account-dashboard.module";
import {ApiTokensModule} from "./api-tokens/api-tokens.module";
import {NgxIntlTelInputModule} from "ngx-intl-tel-input";
import { ClipboardModule } from 'ngx-clipboard';
import { UserTasksTabsComponent } from './user-tasks-tabs/user-tasks-tabs.component';
import { ActionsModule } from '../actions/actions.module';
import { AccountSwitcherComponent } from './account-switcher/account-switcher.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { UserDocsComponent } from './user-docs/user-docs.component';
import { BackgroundExportsComponent } from './background-exports/background-exports.component';
import { BackgroundExportsFilterComponent } from './background-exports-filter/background-exports-filter.component';

@NgModule({
  declarations: [
    UserDetailsComponent,
    UserMessagesComponent,
    UserTasksComponent,
    UserTasksEditComponent,
    UserTasksTabsComponent,
    UserTasksFilterComponent,
    UserMessagesViewComponent,
    ClientSitesComponent,
    UserMessagesFilterComponent,
    UserDynamicFormsComponent,
    UserDynamicFormsEditComponent,
    UserDynamicFormsTemplateSelectorComponent,
    ClientSitesSelectorComponent,
    UserDynamicFormsCreateWizardComponent,
    UserDynamicFormsFilterComponent,
    AccountSwitcherComponent,
    UserDocsComponent,
    BackgroundExportsComponent,
    BackgroundExportsFilterComponent,
    AccountAccessComponent,
    AccountAccessReasonDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    UserRoutingModule,
    DirectivesModule,
    PipesModule,
    MatComponentsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatMenuModule,
    MatIconModule,
    MatListModule,
    MatDatepickerModule,
    MatTabsModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatBadgeModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatCardModule,
    BsDatepickerModule,
    MatRadioModule,
    UtilsModule,
    SharedModule,
    FilesModule,
    MultiAccountDashboardModule,
    ApiTokensModule,
    NgxIntlTelInputModule,
    ReactiveFormsModule,
    ClipboardModule,
    ActionsModule,
    NgxSpinnerModule
  ]
})
export class UserModule {}
